import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
/*import { updateCart, removeFromCart } from "../actions/cartActions";*/
import { utils } from "../common/utils";
import { withTranslation } from 'react-i18next';
import CurrencyFormat from '../components/CurrencyFormat';

class OrderSummary extends Component {

    render() {

        const { t, checkoutSale, showTitle, settings } = this.props;
        if (!checkoutSale) return <div />;
       //debugger;
        //const saleTotal = checkoutSale.totalCustomerPrice + checkoutSale.totalShippingHandling + checkoutSale.totalPSTTaxValue + checkoutSale.totalHSTGSTTaxValue;
        //console.log(`${saleTotal} - ${checkoutSale.saleTotalAfterDiscount} -  ${checkoutSale.totalCustomerPriceInclDelivery}`)
        const taxes = !checkoutSale.isProductPricesIncludeTax ?
            (
                <Fragment>
                    <tr>
                        <td> {`+ ${t("PST Tax")}(${checkoutSale.pstTaxRate}%):`}</td>
                        <td className="text-medium">
                            <CurrencyFormat value={checkoutSale.totalPSTTaxValue} settings={settings} /> 
                        </td>
                    </tr>
                    <tr>
                        <td> {`+ ${t("HST/GST Tax")}(${checkoutSale.hstgstTaxRate}%):`}</td>
                        <td className="text-medium">
                            <CurrencyFormat value={checkoutSale.totalHSTGSTTaxValue} settings={settings} />
                        
                        </td>
                    </tr>
                </Fragment>) :  <Fragment/>;

        const title = showTitle ? (<h3 className="widget-title">{t("Order Summary")}</h3>) : "";
        return (
            <section className="widget widget-order-summary">

                {title}
                <table className="table">
                    <tbody>
                        <tr>
                            <td>{t("Subtotal")}:</td>
                            <td className="text-medium">
                                {/* <CurrencyFormat value={checkoutSale.totalCustomerPrice} settings={settings} /> */}
                                <CurrencyFormat value={checkoutSale.totalCustomerPriceBeforeDiscountCode} settings={settings} />
                            </td>
                        </tr>
                        {checkoutSale.itemDiscountCodes.length > 0 && 
                        <tr>
                            <td>- {t("Discount")}:</td>
                            <td className="text-medium">
                                - <CurrencyFormat value={checkoutSale.totalDiscountCodeAmount} settings={settings} />
                            </td>
                        </tr>}
                        
                        <tr>
                            <td>+ {t("Shipping")}:</td>
                            <td className="text-medium">
                                <CurrencyFormat value={checkoutSale.replaceDeliveryWithShippingAndHandling ? checkoutSale.totalShippingHandling : checkoutSale.totalDeliveryFees} settings={settings} />
                                 
                            </td>
                        </tr>
                        {taxes}

                        <tr>
                            <td> {t("Total")}:</td>
                            <td className="text-lg text-medium">
                                <CurrencyFormat value={checkoutSale.saleTotalAfterDiscount} settings={settings} />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </section>
        );
    }
}

function mapStateToProps({ checkoutSale, settings }) {
    return { checkoutSale, settings };
}


export default withTranslation()(connect(mapStateToProps, null)(OrderSummary));
